import { store } from '@/redux/store';
import ky from 'ky';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const kyHttp = ky.create({
  prefixUrl: API_BASE_URL,
});

const getKyAuthConfig = () => {
  const { token } = store.getState().auth;
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

const kyRequest = {
  get: (url, options = {}) => {
    return kyHttp.get(url, { ...getKyAuthConfig(), ...options });
  },
  post: (url, data, options = {}) => {
    return kyHttp.post(url, { json: data, ...getKyAuthConfig(), ...options });
  },
  put: (url, data, options = {}) => {
    return kyHttp.put(url, { json: data, ...getKyAuthConfig(), ...options });
  },
  delete: (url, options = {}) => {
    return kyHttp.delete(url, { ...getKyAuthConfig(), ...options });
  },
  patch: (url, data, options = {}) => {
    return kyHttp.patch(url, { json: data, ...getKyAuthConfig(), ...options });
  },
};

export default kyHttp;
export { kyRequest, API_BASE_URL, getKyAuthConfig };
